export default {
  TYPE_YOUTUBE: 'youtube', // youtube

  types: [
    'youtube',
  ],
}
